<script>
import { Doughnut } from 'vue-chartjs'
import 'chartjs-plugin-labels'

export default {
  extends: Doughnut,
  props: {
    report: {
      type: Object,
      default: function () {
        return {
          correct: 0,
          duplicate: 0,
          bot: 0
        }
      }
    },
    showLabels: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    data () {
      return {
        labels: [this.$t('view-CampaignsCpcDetails.Report.legend.correct'), this.$t('view-CampaignsCpcDetails.Report.legend.duplicate'), this.$t('view-CampaignsCpcDetails.Report.legend.robots')],
        datasets: [{
          data: [this.report.correct, this.report.duplicate, this.report.bot],
          backgroundColor: [
            '#2db67d',
            '#f8cd08',
            '#ebecf0'
          ]
        }]
      }
    },
    options () {
      return {
        legend: {
          display: this.showLabels
        },
        title: {
          display: this.showLabels,
          text: this.$t('view-CampaignsCpcDetails.Report.chart-title'),
          fontSize: 22
        },
        plugins: {
          labels: this.showLabels ? {
            render: function (args) {
              return `${args.value} (${args.percentage}%)`
            },
            fontSize: 16
          } : null
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
</script>
